import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import BannerTwo from "../components/BannerTwo";
import FeatureOne from "../components/FeatureOne";
import TopSellingProducts from "../components/Refine/TopSellingProducts";
import VednorBanners from "../components/Refine/VednorBanners";
import PopularProducts from "../components/Refine/PopularProducts";
import FeaturedProducts from "../components/Refine/FeaturedProducts";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { handleError } from "../utils/functions";
import axiosInstance from "../config/axios.config";
import { toast } from "react-toastify";
import TopShops from "../components/Refine/TopShops";
const HomePageTwo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    categories: [],
    subcategories: [],
    banners: [],
    popularProducts: [],
    bestSellerProducts: [],
    shops: [],
    shopBanners: [],
  });

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get("/home");
        if (!data.error) {
          setData(data.data);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  return (
    <>
      <ColorInit color={true} />

      <ScrollToTop smooth color="#FA6400" />

      <Preloader isLoading={isLoading} />

      <HeaderTwo category={false} categories={data.categories} subcategories={data.subcategories} />

      <BannerTwo banners={data.banners} categories={data.categories} subcategories={data.subcategories} />

      <FeatureOne categories={data.categories} />

      <PopularProducts popularProducts={data.popularProducts} />

      <FeaturedProducts popularProducts={data.popularProducts} />

      {data.shopBanners.length > 0 && <VednorBanners shopBanners={data.shopBanners} />}

      <TopSellingProducts bestSellerProducts={data.bestSellerProducts} />

      <TopShops shops={data.shops} />

      <FooterTwo />

      <BottomFooter />
    </>
  );
};

export default HomePageTwo;
